import axios from "axios";
import CacheStorageService from "./cacheStorage.service";
import LocalStorageService from "./localStorage.service";

class DocumentLogsService {
    constructor(apiUrl) {
        this.apiUrl = apiUrl;
        this.cache = new CacheStorageService();
    }

    /** @type {string} */
    token = LocalStorageService.retrieveItem("token").idToken

    /**
    * @author Adrian Montemayor
    * @description Get all documentlogs
    * @date 02-10-2023
    * @param {String} token
    * @returns {Object}
    * @memberof CompanyService
    */
    async getDocumentLogs(clientId, timezone, token, documentId) {
        // const cache = new CacheStorageService();
        // cache.deleteUrlFromCache('/categories')
        let url = `${this.apiUrl}/document-logs?clientId=${clientId}&timezone=${encodeURIComponent(timezone)}`
        if (documentId) {
            url = url + `&documentId=${documentId}`
        }

        let response = await axios.get(
            url,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        return response.data;
    }

    /**
     * @description Get document logs by date range
     * @date 02-10-2023
     * @param {string} [documentId]
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {number} [limit] - Maximum number of records to return
     * @param {number} [offset] - Number of records to skip    
     * @param {string} [searchTerm] - Search term to filter by name
     * @returns {Promise<import("../types/api.types").ApiResponse<import("../types/document-logs.types").getLogsResponse>>}
     * @memberof CompanyService
     */
    async getLogs(documentId, startDate, endDate, limit, offset, searchTerm) {
        let url = new URL(`${this.apiUrl}/binnacle`);
        if (documentId) url.searchParams.append('documentId', documentId);
        if (startDate) url.searchParams.append('startDate', startDate);
        if (endDate) url.searchParams.append('endDate', endDate);
        if (offset !== undefined && offset !== null) url.searchParams.append('offset', offset)
        if (limit !== undefined && limit !== null) url.searchParams.append('limit', limit)
        url.searchParams.append('timezone', Intl.DateTimeFormat().resolvedOptions().timeZone);

        if (searchTerm && searchTerm.trim() !== '') {
            url.searchParams.append('documentName', searchTerm.trim())
        }

        const urlString = url.toString()

        if (searchTerm && searchTerm.trim() !== '') {
            let response = await axios.get(
                urlString,
                {
                    headers: {
                        Authorization: `Bearer ${this.token}`,
                    },
                }
            )
            return response.data
        }

        try {
            let response = await this.cache.fetchData(urlString, this.token, 1)
            return response.data
        } catch (error) {
            let response = await axios.get(
                urlString,
                {
                    headers: {
                        Authorization: `Bearer ${this.token}`,
                    },
                }
            )
            return response.data
        }
    }

}

export { DocumentLogsService as default }
